import { useApi } from "@/lib/api";
import { AdminTitle, Table } from "./AdminUi";

export default function AdminAudit() {
  const { data } = useApi("/admin/audit");
  return (
    <div data-testid="admin-audit">
      <AdminTitle title="Audit log">The 300 most recent sensitive actions by staff.</AdminTitle>
      <Table head={["When", "Who", "Role", "Action", "Target", "Detail"]} testId="audit-table">
        {(data || []).map((r) => (
          <tr key={r.id}>
            <td className="px-4 py-2.5 whitespace-nowrap">{new Date(r.at).toLocaleString("en-GB")}</td>
            <td className="px-4 py-2.5">{r.actor_email}</td>
            <td className="px-4 py-2.5">{r.actor_role}</td>
            <td className="px-4 py-2.5 font-medium">{r.action}</td>
            <td className="px-4 py-2.5">{r.target}</td>
            <td className="px-4 py-2.5">{r.detail}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
